module.exports = __webpack_public_path__ + "static/media/5.01637426.jpg";